import { Action } from '@ngrx/store';
import { IEmailConfiguration } from '../../../commons';

export enum EmailConfigurationActionTypes {
  LoadEmailConfigurationState = '[EmailConfiguration] Load EmailConfiguration State',
  LoadEmailConfigurationStateSuccess = '[EmailConfiguration] Load EmailConfiguration State Success',
  LoadEmailConfigurationStateFail = '[EmailConfiguration] Load EmailConfiguration State Fail',
  SubmitEmailTemplate = '[EmailConfiguration] Submit Email Template State',
  EmailConfigurationScreenErrorReset = '[EmailConfiguration] EmailConfiguration Screen Error Reset'

}

export class LoadEmailConfigurationState implements Action {
  readonly type = EmailConfigurationActionTypes.LoadEmailConfigurationState;
}

export class LoadEmailConfigurationStateSuccess implements Action {
  readonly type = EmailConfigurationActionTypes.LoadEmailConfigurationStateSuccess;
  constructor(public payload: IEmailConfiguration ) {}
}

export class LoadEmailConfigurationStateFail implements Action {
  readonly type = EmailConfigurationActionTypes.LoadEmailConfigurationStateFail;
  constructor(public payload: any) {}
}
export class SubmitEmailTemplate implements Action {
  readonly type = EmailConfigurationActionTypes.SubmitEmailTemplate;
  constructor(public payload: any) {}
}

export class EmailConfigurationScreenErrorReset implements Action {
  readonly type = EmailConfigurationActionTypes.EmailConfigurationScreenErrorReset;
}

export type EmailConfigurationActions = 
  LoadEmailConfigurationState
  | LoadEmailConfigurationStateSuccess
  | LoadEmailConfigurationStateFail
  | SubmitEmailTemplate
  | EmailConfigurationScreenErrorReset;